// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3dP7G","selected":"Chip_selected__1ERgb"};